module.exports = __webpack_public_path__ + "img/Maryland outline.377f9db8.png";